/**
 * İkas tam ürün gönderimi öncesi doğrulama (frontend ile server/utils/validateIkasReadyProduct.js uyumlu).
 */

function hasPositiveWebPrice(product) {
  const chain = [
    product?.ws_websiteSatisFiyati,
    product?.siteFiyati,
    product?.webSiteFiyati,
    product?.websiteSatisFiyati,
    product?.webFiyati
  ];
  for (const raw of chain) {
    const n = Number(
      String(raw ?? '')
        .trim()
        .replace(',', '.')
        .replace(/[^\d.-]/g, '')
    );
    if (Number.isFinite(n) && n > 0) return true;
  }
  return false;
}

function countFilledImages(product) {
  const urls = [
    product?.gorselURL1,
    product?.gorselURL2,
    product?.gorselURL3,
    product?.gorselURL4,
    product?.gorselURL5
  ];
  return urls.filter((u) => String(u || '').trim()).length;
}

export function validateIkasReadyProduct(product) {
  const missingFields = [];

  const desc = String(product?.aciklama || '').trim();
  if (!desc) missingFields.push('Ürün açıklaması');

  const slug = String(product?.ws_slug || '').trim();
  if (!slug) missingFields.push('Slug');

  const seoTitle = String(product?.ws_seoBaslik || '').trim();
  if (!seoTitle) missingFields.push('SEO başlık');

  const seoDesc = String(product?.ws_seoAciklama || '').trim();
  if (!seoDesc) missingFields.push('SEO açıklama');

  if (!hasPositiveWebPrice(product)) missingFields.push('Web satış fiyatı');

  const filledImages = countFilledImages(product);
  if (filledImages < 5) {
    missingFields.push(`Web görselleri (gorselURL — 5 gerekli; ${filledImages}/5 dolu)`);
  }

  const cats = Array.isArray(product?.ikasCategoryIds)
    ? product.ikasCategoryIds.map((id) => String(id || '').trim()).filter(Boolean)
    : [];
  if (cats.length === 0) missingFields.push('İkas kategori eşleşmesi');

  return {
    ok: missingFields.length === 0,
    missingFields
  };
}
